<template>

    <v-app-bar>

        <div class="d-flex align-center">
            <!-- Logo -->
            <div>
                <img src="@assets/images/header/logo-nlb-buy&go.svg" alt="NLB Buy&Go logo" class="logo">
            </div>
        </div>

        <div class="d-flex ga-4 align-center">

            <!-- Navigation links -->
            <!-- <v-list v-if="appStore.User.CanAccessPortal" :disabled="appStore.User.NeedsToChangePassword" -->
            <v-list class="app-bar__links d-none d-lg-flex">

                <!-- Pogosta vprašanja -->
                <v-list-item title="Pogosta vprašanja"
                    href="https://www.nlbbuygo.si/nlb-buy-go/pogosta-vprasanja/sem-kupec" target="_blank"
                    :prepend-icon="route.matched.some(x => x.name == 'pogosta_vprasanja') ? 'custom:iconAppBarFaqActive' : 'custom:iconAppBarFaqInactive'"></v-list-item>

                <!-- Informacije (uporabniški center) -->
                <v-list-item title="Informacije" :to="{ name: 'informacije_home' }"
                    :prepend-icon="route.matched.some(x => x.name == 'informacije_home') ? 'custom:iconAppBarInformacijeActive' : 'custom:iconAppBarInformacijeInactive'"></v-list-item>

                <!-- Splošni pogoji -->
                <v-list-item title="Splošni pogoji" href="https://www.nlbbuygo.si/nlb-buy-go/pravna-vsebina"
                    target="_blank"
                    :prepend-icon="route.matched.some(x => x.name == 'splosni_pogoji') ? 'custom:iconAppBarConditionsActive' : 'custom:iconAppBarConditionsInactive'"></v-list-item>

                <!-- Kontakt -->
                <v-list-item title="Kontakt" :to="{ name: 'kontakt' }"
                    :prepend-icon="route.matched.some(x => x.name == 'kontakt') ? 'custom:iconAppBarContactActive' : 'custom:iconAppBarContactInactive'"></v-list-item>

            </v-list>

            <!-- User menu -->
            <v-menu class="">

                <template v-slot:activator="{ props }">
                    <div v-bind="props">

                        <!-- User name -->
                        <v-btn class="btn btn--primary-fill d-none d-lg-flex">
                            {{ dataEditingStore.Podatki.Firstname + ' ' + dataEditingStore.Podatki.Surname }}
                        </v-btn>

                    </div>
                </template>

                <v-list>
                    <v-list-item v-for="(item, i) in navBtns" :key="i" :title="item.title"
                        :active="$router.currentRoute.value.matched.some(route => route.name == item.routerName) && $router.currentRoute.value.params.flowType != 'vloga'"
                        @click="changeRoute(item)">
                    </v-list-item>
                </v-list>

            </v-menu>

            <!-- Navigation icon -->
            <v-app-bar-nav-icon class="d-flex d-lg-none"
                @click="appStore.AppHelpers.ShowNavigation = appStore.AppHelpers.ShowNavigation == null ? true : !appStore.AppHelpers.ShowNavigation">
            </v-app-bar-nav-icon>

        </div>

    </v-app-bar>
</template>

<script setup lang="ts">
    import { commClient } from "fw4-library";
    import router from "@app/router";
    import { useFw4Store, MessageBoxPredefinedButtons, MessageBoxButtonType } from "fw4-library";
    import { useDataEditingStore } from "@/app/store/app/settings/settings-store";
    import { usePublicStore } from "@/app/store/public/public-store";
    import { useRoute } from "vue-router";
    import { useAppStore } from "@/app/store/app/app-store";

    const appStore = useAppStore();
    const fw4 = useFw4Store();
    const route = useRoute();
    const publicStore = usePublicStore();
    const dataEditingStore = useDataEditingStore();

    let navBtns = appStore.AppNavButtons = [
        {
            title: "Nastavitve uporabiškega računa",
            routerName: "nastavitev_profila",
        },
        {
            title: "Vnos in urejanje podatkov",
            routerName: "nastavitev_stranka",
        },
        {
            title: "Izhod",
            routerName: "",
            runFunction: () => {
                LogOut()
            },
        }
    ];

    function changeRoute(item: any) {
        if (item.routerName == "nastavitev_stranka" && router.currentRoute.value.params.flowType == "vloga") {
            fw4.ShowMessageBox("Preklic oddaje vloge", "Ste prepričani, da želite preklicati postopek oddaje vloge za vnaprej odobreno plačilo na obroke?", [
                MessageBoxPredefinedButtons[MessageBoxButtonType.Cancel],
                MessageBoxPredefinedButtons[MessageBoxButtonType.OK]
            ]).then((buttonId: any) => {
                if (buttonId == "OK") {
                    router.push({ name: item.routerName });
                }
            });

            return;
        }
        if (item.runFunction != undefined) {
            item.runFunction();
        }
        else {
            router.push({ name: item.routerName });
        }
    }

    //Logout
    function logOutAccept() {
        if (commClient.WebSocketConnected) {
            publicStore.userLogOut();
            commClient.disconnectWebSockets();
        }

        dataEditingStore.$reset();
        router.push({ name: "home" });
    };

    function LogOut() {
        fw4.ShowMessageBox("Odjava iz portala", "Ste prepričani, da želite zapustiti portal?", [
            MessageBoxPredefinedButtons[MessageBoxButtonType.Cancel],
            MessageBoxPredefinedButtons[MessageBoxButtonType.OK]
        ]).then((buttonId: any) => {
            if (buttonId == "OK") {
                logOutAccept();
            }
        })
    }



</script>
